import React, { useState, useEffect, useRef } from 'react';
import './ChatContainer.css';
import ChatHistory from '../ChatHistory/ChatHistory';
import InputArea from '../InputArea/InputArea';
import TopBar from "./TopBar/TopBar";

import { useTranslation } from 'react-i18next';
import { getInitialMessages } from './initialMessages';
import { handleUserMessage } from './handleUserMessage';
import backgroundImage from '../../logos_images/ijs_logo_no_background.png';

function ChatContainer({ resetTrigger, isSimplifiedMode }) {
  const { t, i18n } = useTranslation();
  const initialMessages = getInitialMessages(t);
  const [messages, setMessages] = useState(initialMessages);
  const [wasModified, setWasModified] = useState(false);
  const prevWasModifiedRef = useRef(false);
  const [isLoading, setIsLoading] = useState(false); // Loading state

  const chatHistoryRef = useRef(null);

  const addMessage = (messageText) => {
    const newMessage = {
      id: Date.now().toString(),
      type: 'user',
      text: messageText,
    };
    setMessages((prevMessages) => [...prevMessages, newMessage]);
  };

  const handleSuggestionClick = (suggestionText) => {
    addMessage(suggestionText);
  };

  useEffect(() => {
    setMessages(initialMessages);
  }, [resetTrigger]);

  useEffect(() => {
    setMessages(initialMessages);
  }, [i18n.language, t]);

  useEffect(() => {
    const handleMessage = async () => {
      if (messages.length === 0) return;
      const lastMessage = messages[messages.length - 1];
      if (lastMessage.type !== 'user') return;

      const handleWasModified = (newWasModified) => {
        setWasModified(newWasModified);
        prevWasModifiedRef.current = newWasModified;
        if (newWasModified) {
          alert(t("chat.privacy_redaction"));
        }
      };

      await handleUserMessage({
        messages,
        setMessages,
        t,
        language: i18n.language,
        isSimplifiedMode,
        onWasModified: handleWasModified,
      });


    };

    handleMessage();


  }, [messages, t, i18n.language, isSimplifiedMode]);


  return (
      <div
          className="chat-container"
          style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <TopBar chatHistoryRef={chatHistoryRef} messages={messages}/>
        <ChatHistory
            messages={messages}
            onSuggestionClick={handleSuggestionClick}
            isLoading={isLoading}
            chatHistoryRef={chatHistoryRef}
        />
        <InputArea addMessage={addMessage} />
      </div>
  );
}

export default ChatContainer;

